import { useQuery } from '@tanstack/react-query';
import { getProjects, getStats } from '../utils/api';
import { Link } from 'react-router-dom';
import { Building2, TrendingUp, CheckCircle2, XCircle, ArrowRight } from 'lucide-react';

export default function AdminDashboard() {
  const { data: projects = [], isLoading } = useQuery({ queryKey: ['projects'], queryFn: getProjects });
  const { data: stats } = useQuery({ queryKey: ['stats'], queryFn: getStats });

  return (
    <div style={{ padding: 28 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Dashboard</h1>
        <p style={{ color: 'var(--text3)', fontSize: 14 }}>Overview of all SRG Real Estate projects</p>
      </div>

      {/* Global stat cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 28 }}>
        {[
          { label: 'Grand Total', val: stats?.grand_total || 0, color: 'var(--blue)', icon: Building2 },
          { label: 'Available', val: stats?.total_available || 0, color: 'var(--green)', icon: CheckCircle2 },
          { label: 'Booked', val: stats?.total_booked || 0, color: 'var(--red)', icon: XCircle },
          { label: 'Not For Sale', val: stats?.total_nfs || 0, color: 'var(--gray)', icon: TrendingUp },
        ].map(({ label, val, color, icon: Icon }) => (
          <div key={label} className="stat-card">
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
              <Icon size={22} color={color} />
            </div>
            <div className="stat-val" style={{ color }}>{val}</div>
            <div className="stat-lbl">{label}</div>
          </div>
        ))}
      </div>

      {/* Projects Table */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">All Projects</span>
          <Link to="/admin/projects" className="btn btn-green btn-sm">
            Manage Projects <ArrowRight size={14} />
          </Link>
        </div>
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><div className="spinner" /></div>
        ) : (
          <div className="tbl-wrap">
            <table>
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Type</th>
                  <th>Total</th>
                  <th>Available</th>
                  <th>Booked</th>
                  <th>NFS</th>
                  <th>% Booked</th>
                  <th>Contact</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {projects.map(p => (
                  <tr key={p.id}>
                    <td style={{ fontWeight: 600 }}>{p.name}</td>
                    <td style={{ color: 'var(--text2)', fontSize: 12 }}>{p.type}</td>
                    <td className="mono">{p.total}</td>
                    <td><span className="badge badge-available">{p.available}</span></td>
                    <td><span className="badge badge-booked">{p.booked}</span></td>
                    <td><span className="badge badge-nfs">{p.nfs}</span></td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div className="progress-track" style={{ width: 60 }}>
                          <div className="progress-fill" style={{ width: `${p.total > 0 ? Math.round((p.booked / p.total) * 100) : 0}%` }} />
                        </div>
                        <span className="mono" style={{ fontSize: 12 }}>
                          {p.total > 0 ? Math.round((p.booked / p.total) * 100) : 0}%
                        </span>
                      </div>
                    </td>
                    <td style={{ fontSize: 12 }}>📞 {p.contact}</td>
                    <td>
                      <Link to={`/admin/projects/${p.id}/plots`} className="btn btn-outline btn-sm">
                        Manage Plots
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
